import Icon from "./Icon";

interface ContribCardProps {
  title: string;
  text: string;
  image: string;
  technologies: string;
  live: string;
}

export default function ContribCard({
  title,
  text,
  image,
  technologies,
  live,
}: ContribCardProps) {
  return (
    <a className="contrib-card" href={live} target="_blank" rel="noreferrer">
      <div className="contrib-media">
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className="contrib-body">
        <div className="contrib-head">
          <h4>{title}</h4>
          <Icon name="arrow" style={{ width: 16, height: 16, opacity: 0.55 }} />
        </div>
        <p>{text}</p>
        <div className="proj-tags">
          {technologies.split(" ").map((w, i) => (
            <span key={i} className="tag">
              {w}
            </span>
          ))}
        </div>
      </div>
    </a>
  );
}
